export interface IHomepageProductSelection<T> {
  products: T[];
  source: "curated" | "newest";
}

export const selectHomepageProducts = <T>(
  curated?: T[] | null,
  newest?: T[] | null
): IHomepageProductSelection<T> =>
  curated && curated.length > 0
    ? { products: curated, source: "curated" }
    : { products: newest || [], source: "newest" };
